import React from 'react';
import { Link } from 'react-router-dom'
import './card-style.css'
import EditNewQuestions1 from '../EditNewQuestions1';
import { cx } from '@emotion/css';
import * as styles from '../assignments/assignments.style';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronLeft, faCircle, faCheckCircle, faFileImport, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import EditIcon from "../../assets/images/edit-icon.png";
import batchImg from '../../assets/images/challenge-banner.png';
import spellBowlImg from '../../assets/gen_images/batchesicon.png';
import mathsImg from '../../assets/gen_images/mathematics.png';
import generalMathImg from '../../assets/gen_images/general_math.png';

function EditEventCard(props) {

    function showeditquestions(specificcategory, levels, limits, eventdisplay, category) {
        ////console.log("IN Edit event card")
        ////console.log(category)
        props.showeditquestions(specificcategory, levels, limits, eventdisplay, category);

    }

    function showdeleteevents1(id, name, category) {
        ////console.log(id)

        props.showdeleteevents(id, name, category);
    }

    function ReopenAssignment(id, name, category) {
        ////console.log(id)

        props.ReopenAssignment(id, name, category);


    }
    let { id, name, levels, specificcategory, limits, remainingattempts, totalquestions, eventdisplay, level, eventtype, category, maxnoofparticipants, time } = props.event;
    
    // Determine which image to use
    const nameLower = (name || "").toLowerCase();
    const catLower = (category || "").toLowerCase();
    let displayImg = batchImg;
    
    if (nameLower.includes('spellbowl') || catLower.includes('spellbowl')) {
        displayImg = spellBowlImg;
    } else if (nameLower.includes('mathbowl') || catLower.includes('mathbowl')) {
        displayImg = mathsImg;
    } else if (nameLower.includes('math') || catLower.includes('math')) {
        displayImg = generalMathImg;
    }
    return (
        <div style={{ position: 'relative', width: '100%', height: '100%' }}>
            <div className="plusDelete" style={{ position: 'absolute', top: '10px', left: '10px', zIndex: 30, display: 'flex', gap: '5px' }}>
                <button 
                    onClick={(e) => { e.stopPropagation(); console.log('Delete clicked'); showdeleteevents1(id, name, category); }}
                    style={{ background: 'rgba(255,255,255,0.9)', border: 'none', borderRadius: '50%', width: '30px', height: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', boxShadow: '0 2px 10px rgba(0,0,0,0.1)', pointerEvents: 'auto' }}
                >
                    <FontAwesomeIcon icon={faTrashAlt} color="#ff4d4d" />
                </button>
                <button 
                    onClick={(e) => { e.stopPropagation(); console.log('Reopen clicked'); ReopenAssignment(id, name, category); }}
                    style={{ background: 'rgba(255,255,255,0.9)', border: 'none', borderRadius: '50%', width: '30px', height: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', boxShadow: '0 2px 10px rgba(0,0,0,0.1)', pointerEvents: 'auto' }}
                >
                    <FontAwesomeIcon icon={faFileImport} color="#2ec32b" />
                </button>
            </div>

            <div style={{ position: 'absolute', top: '10px', right: '10px', zIndex: 30 }}>
                <Link 
                    to={{ pathname: "/editchallenge", state: { id: id, name: name, category: category, level: level, totalquestions: totalquestions, time: time, specificcategory: specificcategory, eventtype: eventtype, levels: levels, limits: limits, eventdisplay: eventdisplay, maxnoofparticipants: maxnoofparticipants } }}
                    onClick={(e) => { e.stopPropagation(); console.log('Edit Challenge clicked'); }}
                >
                    <button style={{ background: 'rgba(255,255,255,0.9)', border: 'none', borderRadius: '50%', width: '30px', height: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', boxShadow: '0 2px 10px rgba(0,0,0,0.1)', pointerEvents: 'auto' }}>
                        <img src={EditIcon} alt="" style={{ width: '16px' }} />
                    </button>
                </Link>
            </div>

            <img src={displayImg} alt={name} className={cx(styles.cardImage)} />
            
            <div className={cx(styles.cardTitle)}>{name}</div>
            <div className={cx(styles.cardCount)}>
                {totalquestions} Questions • Level {level}
            </div>

            <div style={{ display: 'flex', gap: '10px', width: '100%', marginTop: '20px', zIndex: 30 }}>
                {maxnoofparticipants != 50000 && (
                    <Link 
                        to={{ pathname: "/editevents", state: { specificcategory: specificcategory, levels: levels, limits: limits, eventdisplay: eventdisplay, category: category } }}
                        style={{ flex: 1, textDecoration: 'none', pointerEvents: 'auto' }}
                        onClick={(e) => { e.stopPropagation(); console.log('Edit Questions clicked'); }}
                    >
                        <button className="btn btn-primary w-100 py-2 rounded-pill" style={{ fontSize: '12px', fontWeight: '600', textTransform: 'uppercase' }}>
                            Edit Questions
                        </button>
                    </Link>
                )}

                <Link 
                    to={{ pathname: "/dashboard", state: { id: id, name: name, category: category, level: level } }}
                    style={{ flex: 1, textDecoration: 'none', pointerEvents: 'auto' }}
                    onClick={(e) => { e.stopPropagation(); console.log('Dashboard clicked'); }}
                >
                    <button className="premium-dashboard-btn">
                        Dashboard
                    </button>
                </Link>
            </div>
        </div>
    );
}






export default EditEventCard;
